import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserStatus } from "./generalTypes";

export interface User {
    email: string;
    title?: string;
    firstName: string;
    lastName: string;
    jobTitle: string;
    otherJobTitle?: string;
    id?: string;
    password?: string;
    status: UserStatus;
    phoneNumber?: string;
}

export const initialState: User = {
    email: "",
    title: "",
    firstName: "",
    lastName: "",
    jobTitle: "",
    phoneNumber: "",
    status: UserStatus.Inactive
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        updateUser(state, action: PayloadAction<User>) {
            state.email = action.payload.email;
            state.title = action.payload.title;
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.jobTitle = action.payload.jobTitle;
            state.otherJobTitle = action.payload.otherJobTitle;
            state.password = action.payload.password;
            state.id = action.payload.id;
            state.status = action.payload.status;
            state.phoneNumber = action.payload.phoneNumber;
        }
    }
});

export const { updateUser } = userSlice.actions;

export default userSlice.reducer;
